<template>
  <v-card hover ripple shaped>
    <v-card-title class="text-h5">{{ title }}</v-card-title>
    <v-card-text>
      <a :href="destination">
        <img
          :src="graphic"
          class="preview-link"
        />
      </a>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: 'Preview',
  props: {
    destination: {
      type: String,
      default: ''
    },
    graphic: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    
  }),
  methods: {
    onClick () {
      window.location.href = this.destination
    }
  }
};
</script>
<style>
.preview-link {
  cursor: pointer;
  height: 15vh;
  min-height: 250px;
  min-width: 250px;
  border-radius: 30px;
  opacity: 0.50
}

.preview-link:hover {
  opacity: 1.0
}
</style>